import React, { useState, useEffect, useContext } from 'react';

import { useAppVersionStore } from "@mirinae/stores/appVersion";
import { UserContext } from '@mirinae/react-auth';

import MembersRoutes from '@mirinae/members/membersRoutes';

import HeaderContainer from '@mirinae/members/containers/common/HeaderContainer';
import FooterContainer from '@mirinae/members/containers/common/FooterContainer';
import FeedbackContainer from '@mirinae/members/containers/feedback/FeedbackContainer';
import ContentsLayout from '@mirinae/members/components/layout/ContentsLayout';
import GlobalContext from '@mirinae/members/modules/contexts/globalContext';

import UpgradeToPP2MembersPopup from '@mirinae/members/components/banners/UpgradeToPP2AppPopup';

const Members = () => {
    const [userContext] = useContext(UserContext);
    const { isApp, versionParam, appVersion, isProEnabledVersion, isPricePlan3PlusEnabled, displayMustUpgradeApp } = useAppVersionStore();

    const [globalData, setGlobalData] = useState({
        displayFeedback: 0,
        prefs: { ...userContext.user.preferences },
        versionParam,
        appVersion,
        isProEnabledVersion,
        isPricePlan3PlusEnabled,
        displayMustUpgradeApp,
    });

    useEffect(() => {
        if (userContext?.user?.preferences)
            setGlobalData(prev => ({ ...prev, prefs: userContext.user.preferences }));
    }, [userContext]);

    return (
        <GlobalContext.Provider value={[globalData, setGlobalData]}>
            <div id="members-app-root">
                <HeaderContainer />
                <ContentsLayout>
                    <MembersRoutes />
                </ContentsLayout>
                {/* update app banner */}{/* <MobileUpdateBannerContainer isMembers={isMembers} /> */}
                {/* upgrade pro popup */}{ globalData.displayMustUpgradeApp && <UpgradeToPP2MembersPopup /> }
                <FooterContainer />
                <FeedbackContainer />
            </div>
        </GlobalContext.Provider>
    );
};

export default Members;

